import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = (location.state as { from?: string })?.from || '/admin';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await login(email, password);
      navigate(from, { replace: true });
    } catch (err: any) {
      setError(err.response?.data?.message || err.response?.data?.errors?.email?.[0] || 'שגיאת התחברות');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-rose-50/30 flex items-center justify-center p-4" dir="rtl" style={{ fontFamily: "'Heebo', sans-serif" }}>
      <div className="bg-white rounded-3xl border-2 border-rose-100 p-8 w-full max-w-md shadow-lg">
        <div className="text-center mb-8">
          <img
            src="https://storage.readdy-site.link/project_files/d20edc57-a850-4bd5-be1a-2dc2615daee8/f24373d3-615b-4526-a5fc-5e05b464179e_----.png?v=aee108af124d23a6400d2fdc7786381b"
            alt="לוגו"
            className="h-14 w-auto mx-auto mb-4"
          />
          <h1 className="text-xl font-bold text-gray-800">התחברות למערכת</h1>
          <p className="text-sm text-gray-500 mt-1">ברוכים הבאים למערכת הניהול</p>
        </div>

        {error && (
          <div className="bg-red-50 border-2 border-red-200 rounded-xl p-3 mb-5 text-sm text-red-600 text-center font-semibold">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1.5">אימייל</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
              className="w-full px-4 py-2.5 rounded-xl border-2 border-rose-100 bg-white focus:outline-none focus:border-rose-300 text-sm transition-all"
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1.5">סיסמה</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="********"
              required
              className="w-full px-4 py-2.5 rounded-xl border-2 border-rose-100 bg-white focus:outline-none focus:border-rose-300 text-sm transition-all"
            />
          </div>

          <button
            type="submit"
            disabled={submitting}
            className="w-full py-2.5 rounded-xl bg-rose-400 text-white text-sm font-bold hover:bg-rose-500 transition-all disabled:opacity-50 cursor-pointer"
          >
            {submitting ? 'מתחבר...' : 'התחבר'}
          </button>
        </form>
      </div>
    </div>
  );
}
